/*
 *******************************************************************************
 * 
 *  Filename:   ./constants/actionTypeGoCampaign_OfficeGroups.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Office Group Type Action Type constant definitions.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Thursday, July 11, 2019 - 02:26:10 PM (CST)
 *
 *  Notes:
 *
 *
 *  Revisions:
 *      07/11/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

export const OFFICEGROUP_LIST_CONTAINER_LOADED = 'OFFICEGROUP_LIST_CONTAINER_LOADED';
export const OFFICEGROUP_LIST_CONTAINER_UNLOADED = 'OFFICEGROUP_LIST_CONTAINER_UNLOADED';
export const OFFICEGROUP_LIST_TABLE_LOADED = 'OFFICEGROUP_LIST_TABLE_LOADED';
export const OFFICEGROUP_LIST_TABLE_UNLOADED = 'OFFICEGROUP_LIST_TABLE_UNLOADED';

export const OFFICEGROUP_LIST_CHANGE_GROUP = 'OFFICEGROUP_LIST_CHANGE_GROUP';
export const OFFICEGROUP_SELECT_ROW = 'OFFICEGROUP_SELECT_ROW';

export const OFFICEGROUP_ADD = 'OFFICEGROUP_ADD';
export const OFFICEGROUP_EDIT = 'OFFICEGROUP_EDIT';
export const OFFICEGROUP_DELETE = 'OFFICEGROUP_DELETE';
export const OFFICEGROUP_OPEN_WARNING = 'OFFICEGROUP_OPEN_WARNING';
export const OFFICEGROUP_CLOSE_WARNING = 'OFFICEGROUP_CLOSE_WARNING';
export const OFFICEGROUP_DELETE_DISABLE = 'OFFICEGROUP_DELETE_DISABLE';
export const OFFICEGROUP_VIEW_CHILD_ITEMS = 'OFFICEGROUP_VIEW_CHILD_ITEMS';

export const OFFICEGROUP_EDIT_CONTAINER_LOADED = 'OFFICEGROUP_EDIT_CONTAINER_LOADED';
export const OFFICEGROUP_EDIT_CONTAINER_UNLOADED = 'OFFICEGROUP_EDIT_CONTAINER_UNLOADED';
export const OFFICEGROUP_EDIT_FORM_LOADED = 'OFFICEGROUP_EDIT_FORM_LOADED';
export const OFFICEGROUP_EDIT_FORM_UNLOADED = 'OFFICEGROUP_EDIT_FORM_UNLOADED';

export const OFFICEGROUP_SET_GROUP_SELECT = 'OFFICEGROUP_SET_GROUP_SELECT';
export const OFFICEGROUP_EDIT_DATA_LOAD = 'OFFICEGROUP_EDIT_DATA_LOAD';

export const OFFICEGROUP_EDIT_CONTAINER_SUBMIT = 'OFFICEGROUP_EDIT_CONTAINER_SUBMIT';
export const OFFICEGROUP_EDIT_CONTAINER_CANCEL = 'OFFICEGROUP_EDIT_CONTAINER_CANCEL';


// WEBPACK FOOTER //
// ./src/constants/actionTypeGoCampaign_OfficeGroups.js